import { log } from 'log';
import { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { languageService } from 'js/services/language.service';

export const useRequestDesktopPacket = ({
    sdk,
    license,
    transactionID,
    userId,
    identifierType
}) => {
    const lang = useUserSelector(prop('lang'));
    const twoLetterLang = languageService.getTwoLetterLanguage(lang);

    return useCallback(() => {
        log('gcReq', { transactionID, license });

        sdk.setLicense(license);
        sdk.setGeolocationReason('bet');
        sdk.setUserId(userId);
        sdk.customFields.set('transactionId', transactionID);
        sdk.customFields.set('identifier_type', identifierType);
        sdk.customFields.set('language', twoLetterLang);
        sdk.requestGeolocation();
    }, [
        sdk,
        license,
        twoLetterLang,
        transactionID,
        userId,
        identifierType
    ]);
};
